import React, { useEffect } from 'react';
import Header from '../../components/Global/Header';
import { HeaderType } from '../../types/Header';
import { selectStudyPhase, StudyPhase } from '../../slices/study/studySlice';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

const StudyLayout: React.FC = () => {
  const studyPhase = useSelector(selectStudyPhase);

  const isLoadedStudySessionAndContent = true;
  const pageSwitch = true;

  useEffect(() => {
    document.body.classList.add('study-theme');
    return () => {
      document.body.classList.remove('study-theme');
    };
  }, []);

  useEffect(() => {
    document.body.classList.remove('study-theme--qbank');
    document.body.classList.remove('study-theme--qbankReview');
    if (studyPhase) {
      document.body.classList.add('study-theme--' + studyPhase);
      return () => {
        document.body.classList.remove('study-theme--qbank');
        document.body.classList.remove('study-theme--qbankReview');
      };
    }
  }, [studyPhase]);

  return (
    <>
      <div
        className={`study ${isLoadedStudySessionAndContent && pageSwitch ? 'is-loaded' : ''} ${studyPhase === StudyPhase.BLOCK_REVIEW ? 'is-review' : ''} ${studyPhase === StudyPhase.FLASHCARD_STUDY ? 'phase--flashcard' : ''} ${studyPhase === StudyPhase.BLOCK_SELECT ? 'phase--qbank-start' : ''}`}
      >
        <div className="study_main">
          <Header type={HeaderType.study} />
          <div
            className="study_main_body"
            style={
              studyPhase === StudyPhase.BLOCK_STUDY ||
              studyPhase === StudyPhase.BLOCK_REVIEW
                ? { overflow: 'hidden' }
                : {}
            }
          >
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default StudyLayout;
